var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75474 0C4.76596 0 0.72168 4.04428 0.72168 9.03306C0.72168 13.2692 3.63827 16.8239 7.57271 17.8002V11.7936H5.7101V9.03306H7.57271V7.84359C7.57271 4.76909 8.96417 3.34404 11.9827 3.34404C12.555 3.34404 13.5425 3.45641 13.9464 3.56842V6.07058C13.7333 6.04818 13.3629 6.03698 12.9029 6.03698C11.4219 6.03698 10.8495 6.59811 10.8495 8.05677V9.03306H13.8001L13.2932 11.7936H10.8495V18C15.3224 17.4598 18.7882 13.6515 18.7882 9.03306C18.7878 4.04428 14.7435 0 9.75474 0Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.44c0c4abd07d9ef8a1ab027132880f88.svg";
export { ForwardRef as ReactComponent };